import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import LabImg from '../../../../Assets/images/flawless-img/lab-img.jpg'
import NaturalImg from '../../../../Assets/images/flawless-img/natural-img.png'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

const LabNatural = () => {
    const history = useHistory();
  return (
    <div className='f_lab_nbatural_Daimond_section'>
        <Container className='showcase-container'>
            <Row>
                <Col sm={12} md={6} lg={6}>
                    <div className='f_lab_diamond_box'>
                        <div className='img_outer'>
                            <Image src={LabImg} alt="LAb Diamond Image"/>
                        </div>
                         <h6>Lab Grown Diamonds</h6>
                         <button onClick={()=> history.push("/diamonds/lab")} className='f_shop_now_btn'>Shop Now</button>
                    </div>
                </Col>
                <Col sm={12} md={6} lg={6}>
                    <div className='f_lab_diamond_box'>
                         <Image src={NaturalImg} alt="LAb Diamond Image"/>
                         <h6>Natural Diamonds</h6>
                         <button onClick={()=> history.push("/diamonds")} className='f_shop_now_btn'>Shop Now</button>
                    </div>
                </Col>
            </Row>

        </Container>
      
    </div>
  )
}

export default LabNatural
